import React from 'react';
import Image from './Image';

interface AppsHeaderProps {
  title: string;
  subsection?: string;
  onReset?: () => void;
}

const AppsHeader: React.FC<AppsHeaderProps> = ({
  title,
  subsection,
  onReset
}) => {
  return (
    <div className="text-center mb-[10px] relative">
      <h1 className="text-[2.0rem] m-0 tracking-[-0.5px]">
        {title} 
        {subsection && (
          <span style={{ fontSize: "1.05rem" }}> ({subsection})</span>
        )}
      </h1>
      {onReset && (
        <div className="absolute left-0 top-0 cursor-pointer">
          <span onClick={onReset}>
            <Image
              src="refresh.png"
              alt="reset"
              width={25}
              onClick={onReset}
              height={25}                    
            />
          </span>
        </div>
      )}
    </div>
  );
};

export default AppsHeader;
